import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CaseTableComponent } from './case-table/case-table.component';
import { CaseThreadComponent } from './case-thread/case-thread.component';
import { StatCardsComponent } from './stat-cards/stat-cards.component';
import { AdminSupportDashboardStore } from 'src/app/services/store/admin-support-dashboard.store';
import { SupportStatus } from 'src/app/common/models/support/admin-support.models';

@Component({
  selector: 'app-admin-support-dashboard',
  standalone: true,
  imports: [CommonModule, TranslateModule, StatCardsComponent, CaseTableComponent, CaseThreadComponent],
  templateUrl: './admin-support-dashboard.component.html',
  styleUrls: ['./admin-support-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminSupportDashboardComponent implements OnInit {
  store = inject(AdminSupportDashboardStore);

  ngOnInit() {
    // The store is app-lifetime (providedIn: 'root'), so a prior visit's
    // thread/stat-filter state must be reset on every entry — not just the
    // first — or a stale thread view can surface instead of the case list.
    this.store.resetOnEntry();
    this.store.loadCounts();
  }

  onTabChanged(tab: SupportStatus) {
    this.store.selectTab(tab);
  }

  onMemberChanged(member: string | null) {
    this.store.setMember(member);
  }

  onRowClicked(supportId: string) {
    this.store.openThread(supportId);
  }

  onPageChanged(page: number) {
    this.store.setPage(page);
  }

  onBack() {
    this.store.backToList();
  }

  onReply(text: string) {
    this.store.sendReply(text);
  }

  onCloseCase() {
    this.store.closeCase();
  }

  onCardClicked(kind: 'open' | 'waiting' | 'email' | 'webapp' | 'new') {
    if (kind === 'open') {
      this.store.clearStatFilter();
    } else {
      this.store.applyStatFilter(kind);
    }
  }
}
